import keycloakAxios from '@/services/axios';
import {removeGroup} from '@/redux-store/slices/groups';
import {store} from '@/redux-store/store';
import {emitGroupChangeEvent} from './change-observable';

export const deleteGroup = async (groupId: string) => {
  const response = await keycloakAxios.delete(`/group/${groupId}`);

  if (response.status >= 300 || response.data.message !== 'Group got deleted') {
    throw new Error(
      `Error deleting group: ${
        response.data.message !== 'Group got deleted'
          ? 'Unexpected response message'
          : `Invalid status code: ${response.status}`
      }`
    );
  }

  emitGroupChangeEvent({
    type: 'deleted',
    id: groupId
  });

  store.dispatch(removeGroup(groupId));

  return response.data;
};
